export type PublishLogEntry = {
  ts?: unknown
  level?: unknown
  service?: unknown
  step?: unknown
  msg?: unknown
  message?: unknown
  data?: unknown
}

export type PublishLogsSummary = {
  requestedByUsername?: string
}

function asString(v: unknown): string {
  return typeof v === 'string' ? v : ''
}

function getNestedString(obj: unknown, path: string[]): string {
  let cur: any = obj
  for (const key of path) {
    if (!cur || typeof cur !== 'object') return ''
    cur = cur[key]
  }
  return asString(cur).trim()
}

function parseRequestedByFromMessage(raw: string): string {
  const s = String(raw || '').trim()
  if (!s) return ''

  // Examples:
  // - "Publish initiated by sherwin with id of <uuid>"
  // - "Publish initiated by sherwin (correlationId=<uuid>)"
  const m = s.match(/publish initiated by\s+(.+?)(?:\s+\(correlationId=|\s+with id of|\s*$)/i)
  return (m?.[1] ?? '').trim()
}

/**
 * Best-effort extraction of the user who initiated the publish run from publish logs.
 * This is intentionally tolerant: logs are JSONL entries, and different services may write different shapes.
 */
export function summarizePublishLogs(entriesRaw: unknown): PublishLogsSummary {
  const entries = Array.isArray(entriesRaw) ? (entriesRaw as PublishLogEntry[]) : []

  for (const e of entries) {
    const fromData = getNestedString(e?.data, ['requestedByUsername'])
    if (fromData) return { requestedByUsername: fromData }

    const fromMessage = parseRequestedByFromMessage(asString((e as any)?.message) || asString((e as any)?.msg))
    if (fromMessage) return { requestedByUsername: fromMessage }
  }

  return {}
}

